import React, { useState } from 'react';
import { getCustomerJourneyTagsAsString } from 'models/enums/customer-journey-tag';
import { useTranslation } from 'react-i18next';
import { useAppSelector } from 'store';
import { selectRobotsData } from 'store/robots/robots-slice-selectors';
import Stack from '@mui/material/Stack';
import TagsRow from './TagsRow';
import TagsForm from './TagsForm';
import { TagType } from 'models/robots/robot-tag';

const TagsInfo: React.FC = () => {
  const { t } = useTranslation();

  const robotsData = useAppSelector((state) => selectRobotsData(state));

  const [tagsFormType, setTagsFormType] = useState<TagType | null>(null);

  const closeFormHandler = () => {
    setTagsFormType(null);
  };

  const customerJourneyTags =
    robotsData.currentRobot?.tags.filter((t) => getCustomerJourneyTagsAsString().includes(t.tag)) ??
    [];
  const customTags =
    robotsData.currentRobot?.tags.filter(
      (t) => !getCustomerJourneyTagsAsString().includes(t.tag),
    ) ?? [];

  return (
    <React.Fragment>
      <Stack spacing={4}>
        <TagsRow
          label={t('label-customer-success-journey')}
          tags={customerJourneyTags}
          onEdit={() => setTagsFormType(TagType.CUSTOMER_JOURNEY)}
        />
        <TagsRow
          label={t('label-robot-tags')}
          tags={customTags}
          onEdit={() => setTagsFormType(TagType.CUSTOM)}
        />
      </Stack>
      {tagsFormType != null && <TagsForm formType={tagsFormType} onClose={closeFormHandler} />}
    </React.Fragment>
  );
};

export default TagsInfo;
